import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../src/assets/knight-transportation-icon-logo.svg'
import _imports_1 from '../../../src/assets/swift-transportation-icon-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-39328972"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-icon" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: "knight-logo"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  class: "swift-logo"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyLogo',
  props: {
    company: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.company == 'knight')
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (_openBlock(), _createElementBlock("img", _hoisted_3))
  ]))
}
}

})